module.exports = __webpack_public_path__ + "img/Network05small.92e3042b.png";